/**
 * Converts bytes to megabytes
 * @param bytes - The number of bytes
 * @returns The size in megabytes
 */
function bytesToMB(bytes: number): number {
  return bytes / (1024 * 1024);
}

/**
 * Formats file size in bytes to a human-readable string
 * @param bytes - The number of bytes
 * @returns Formatted string like "20MB" or "1.5MB"
 */
export function formatFileSize(bytes: number): string {
  const mb = bytesToMB(bytes);

  // If it's a whole number, don't show decimals
  return mb % 1 === 0 ? `${mb}MB` : `${mb.toFixed(1)}MB`;
}
